import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { TOKEN_SYMBOL } from "../../../utils/constants";

interface TrancheComingSoonProps {
  tranche: {
    id: number
    name: string;
    address: string;
    rewards: string;
    minContribution: number;
    status: string;
  }
}

const TrancheComingSoon: React.FC<TrancheComingSoonProps> = ({ tranche }) => {
  return (
    <div className="sc-ad7d017b-3 gNerLz">
      <h3 className="sc-ad7d017b-4 kgcHyO">{tranche.name}</h3>
      <div className="sc-ad7d017b-5 jVpAm">
        <span className="sc-43f175b-1 jfHdxH">reward Asset</span>
        <span className="sc-43f175b-2 kAnXpP">???</span>
      </div>
      <div className="sc-ad7d017b-5 jVpAm">
        <span className="sc-43f175b-1 jfHdxH">Minimum contribution</span>
        <span className="sc-43f175b-2 kAnXpP">???</span>
      </div>
      <div className="sc-ad7d017b-7 fmVvKb">
        <div className="sc-ad7d017b-8 ffuncr">
          <span className="sc-43f175b-1 jfHdxH">Cap: ??? {TOKEN_SYMBOL} / ??? {TOKEN_SYMBOL}</span>
        </div>
        <div className="sc-ad7d017b-9 crUHFC">
          <div className="sc-ad7d017b-10 kuPgqK" />
        </div>
      </div>
      <div className="sc-ad7d017b-6 lePpHb">Coming Soon</div>
    </div>
  );
}
export default TrancheComingSoon;